module.exports = __webpack_public_path__ + "img/ET.c30b19a7.jpg";